import React from 'react';
import './Organizers.css';
import { organizers } from './organizersData';

const Organizers = () => {
  return (
    <>
      <div className="team-div">
      <h1 className="org-heading">Our Team💗</h1>
    <div className='card-container'>
      {organizers.map((organizer) => (
        <article key={organizer.id}>
          <figure>
            <img src={organizer.imgSrc} alt={organizer.name} />
          </figure>
          <h2>{organizer.name}</h2>
          <p>Organizer</p>
        </article>
      ))}
    </div>
      </div>
    </>
  );
};

export default Organizers;
